$(function(){
	interact('.resizable')
		.resizable({
			edges: {
				top   : true,
				left  : false,
				bottom: '.handle',
				right : '.handle'
			}
		}).on('resizemove', event => {

			let { x, y } = event.target.dataset

			x = parseFloat(x) || 0
			y = parseFloat(y) || 0

			Object.assign(event.target.style, {
				width: `${event.rect.width}px`,
				height: `${event.rect.height}px`,
				transform: `translate(${event.deltaRect.left}px, ${event.deltaRect.top}px)`
			})

			Object.assign(event.target.dataset, { x, y })
		})

});